import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  TextField,
  Button,
  Container,
  Typography,
  Box,
  MenuItem,
  Select,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputLabel,
  Snackbar,
  Alert,
  Grid,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const EditarReserva = () => {
  const [reservaId, setReservaId] = useState('');
  const [codigo, setCodigo] = useState('');
  const [reservaValidada, setReservaValidada] = useState(false);
  const [error, setError] = useState('');
  const [locales, setLocales] = useState([]);
  const [localSeleccionado, setLocalSeleccionado] = useState('');
  const [fecha, setFecha] = useState('');
  const [hora, setHora] = useState('');
  const [horariosDisponibles, setHorariosDisponibles] = useState([]);
  const [invitados, setInvitados] = useState(0);
  const [reservaData, setReservaData] = useState(null);
  const [mesasNecesarias, setMesasNecesarias] = useState(0);
  const [mesasDisponibles, setMesasDisponibles] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');
  const [codigoEnviado, setCodigoEnviado] = useState(false);
  const [modoEdicion, setModoEdicion] = useState(true);
  const [numeroOrdenAnulacion, setNumeroOrdenAnulacion] = useState('');
  const [procesoCompletado, setProcesoCompletado] = useState(false);
  const [mensajeExito, setMensajeExito] = useState('');
  const [precioDiferente, setPrecioDiferente] = useState(false);
const [nuevoPrecio, setNuevoPrecio] = useState(0);
const [precioOriginal, setPrecioOriginal] = useState(0);
const [aceptaNuevoPrecio, setAceptaNuevoPrecio] = useState(false);
  // Datos bancarios para el reembolso
  const [datosBancarios, setDatosBancarios] = useState({
    nombreTitular: '',
    rutTitular: '',
    numeroCuenta: '',
    tipoCuenta: '',
    banco: ''
  });
  
  const navigate = useNavigate();

  // Cargar locales al iniciar
  useEffect(() => {
    const fetchLocales = async () => {
      try {
        const response = await axios.get('https://reservas.familypark.cl/backend/ordenes/traerlocales');
        setLocales(response.data);
      } catch (error) {
        setError('Error al cargar los locales.');
        showSnackbar('Error al cargar los locales.', 'error');
      }
    };
    fetchLocales();
  }, []);

  // Manejar el botón atrás del navegador
  useEffect(() => {
    const handleBackButton = (e) => {
      if (reservaValidada && !procesoCompletado) {
        e.preventDefault();
        resetearFormulario();
      }
    };

    window.addEventListener('popstate', handleBackButton);
    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, [reservaValidada, procesoCompletado]);

  // Mostrar Snackbar
  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  // Cerrar Snackbar
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  // Validar si el número de reserva está vacío
  const validarNumeroReserva = () => {
    return reservaId.trim() !== '';
  };

  // Resetear formulario
  const resetearFormulario = () => {
    setReservaId('');
    setCodigo('');
    setReservaValidada(false);
    setError('');
    setLocalSeleccionado('');
    setFecha('');
    setHora('');
    setInvitados(0);
    setReservaData(null);
    setCodigoEnviado(false);
    setModoEdicion(true);
    setNumeroOrdenAnulacion('');
    setProcesoCompletado(false);
    setMensajeExito('');
    setDatosBancarios({
      nombreTitular: '',
      rutTitular: '',
      numeroCuenta: '',
      tipoCuenta: '',
      banco: ''
    });
  };

  // Volver al inicio
  const volverAlInicio = () => {
    resetearFormulario();
    navigate('/');
  };

  // Manejar cambios en los datos bancarios
  const handleDatosBancariosChange = (e) => {
    const { name, value } = e.target;
    setDatosBancarios(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Validar datos bancarios
  const validarDatosBancarios = () => {
    return (
      datosBancarios.nombreTitular.trim() !== '' &&
      datosBancarios.rutTitular.trim() !== '' &&
      datosBancarios.numeroCuenta.trim() !== '' &&
      datosBancarios.tipoCuenta.trim() !== '' &&
      datosBancarios.banco.trim() !== ''
    );
  };

  // Enviar código de validación al correo
  const handleEnviarCodigo = async () => {
    if (!validarNumeroReserva()) {
      showSnackbar('Por favor, ingresa el número de reserva.', 'warning');
      return;
    }

    try {
      const response = await axios.get(`https://reservas.familypark.cl/backend/mof/genpass/${reservaId}`);
      if (response.data.status === 'ok') {
        setError('');
        setCodigoEnviado(true);
        showSnackbar('Se ha enviado un código a su correo para validar que sea el titular de esta reserva.', 'success');
      } else { 
        if(response.data.status === 'late'){
          showSnackbar(response.data.detalle, 'error');
        }else{
          showSnackbar(response.data.detalle, 'error');
        }
      }
    } catch (error) {
      showSnackbar('Error al enviar el código. Intenta nuevamente.', 'error');
    }
  };

  // Validar reserva con el código recibido
  const handleValidarReserva = async () => {
    if (codigo.trim() === '') {
      showSnackbar('Por favor, ingresa el código de validación.', 'warning');
      return;
    }

    try {
      const response = await axios.post('https://reservas.familypark.cl/backend/mof/validarcodigo', {
        reservaId,
        codigo,
      });
      if (response.data.status === 'ok') {
        setReservaValidada(true);
        setReservaData(response.data.ordendata);
        setError('');
        showSnackbar('Reserva validada correctamente.', 'success');

        setLocalSeleccionado(response.data.ordendata.id_local);
        setFecha(response.data.ordendata.ord_fecreserva);
        setInvitados(parseInt(response.data.ordendata.ord_invitados, 10));

        const mesas = Math.ceil(response.data.ordendata.ord_invitados / 25);
        setMesasNecesarias(mesas);

        const horariosResponse = await axios.get(`https://reservas.familypark.cl/backend/ordenes/traerhorariolocal/${response.data.ordendata.id_local}?d=${response.data.ordendata.ord_fecreserva}&o=${response.data.ordendata.id_orden}`);
  
        setHorariosDisponibles(horariosResponse.data);
 
        setHora(response.data.ordendata.id_horario);

        const horarioSeleccionado = horariosResponse.data.find((h) => h.id_hr === response.data.ordendata.id_horario);
        if (horarioSeleccionado) {
          setMesasDisponibles(horarioSeleccionado.cupos_disponibles);
        }
      } else { 
        showSnackbar(response.data.detalle , 'error');
      }
    } catch (error) { 
      showSnackbar('Error al validar la reserva. Intenta nuevamente.', 'error');
    }
  };

  // Cargar horarios disponibles al cambiar la fecha o el local
  useEffect(() => {
    if (localSeleccionado && fecha) {
      const fetchHorarios = async () => {
        try {
          const response = await axios.get(`https://reservas.familypark.cl/backend/ordenes/traerhorariolocal/${localSeleccionado}?d=${fecha}&o=${reservaId}`);
          setHorariosDisponibles(response.data);
          
          // Verificar si hay cambio de precio en el primer horario
          if (response.data.length > 0) {
            const primerHorario = response.data[0];
            if (primerHorario.mantieneprecio === false) {
              setPrecioDiferente(true);
              setNuevoPrecio(primerHorario.nuevoprecio);
              setPrecioOriginal(reservaData.valor_paquete); // Asumiendo que el precio original está en ord_monto
              setAceptaNuevoPrecio(false);
            } else {
              setPrecioDiferente(false);
            }
          }
        } catch (error) { 
          showSnackbar('Error al cargar los horarios disponibles.', 'error');
        }
      };
      fetchHorarios();
    }
  }, [localSeleccionado, fecha]);

  // Validar mesas al cambiar la cantidad de invitados o el horario
  useEffect(() => {
    if (invitados > 0 && hora) {
      const mesas = Math.ceil(invitados / 25);
      setMesasNecesarias(mesas);

      const horarioSeleccionado = horariosDisponibles.find((h) => h.id_hr === hora);
      if (horarioSeleccionado) {
        setMesasDisponibles(horarioSeleccionado.cupos_disponibles);
        if (mesas > horarioSeleccionado.cupos_disponibles) {
          setError('No hay suficientes mesas disponibles para la cantidad de invitados.');
          showSnackbar('No hay suficientes mesas disponibles para la cantidad de invitados.', 'warning');
        } else {
          setError('');
        }
      }
    }
  }, [invitados, hora, horariosDisponibles]);

  // Validar si todos los campos están completos
  const validarCamposCompletos = () => {
    return (
      localSeleccionado.trim() !== '' &&
      fecha.trim() !== '' &&
      hora.trim() !== '' &&
      invitados > 0
    );
  };

  // Validar si el ID de la hora seleccionada existe en los horarios disponibles
  const validarHoraSeleccionada = () => {
    return horariosDisponibles.some((h) => h.id_hr === hora);
  };

  // Guardar cambios en la reserva
  const handleEditarReserva = async () => {
    if (!validarCamposCompletos()) {
      showSnackbar('Por favor, completa todos los campos.', 'warning');
      return;
    }

    if (!validarHoraSeleccionada()) {
      showSnackbar('La hora seleccionada no es válida. Por favor, selecciona una hora disponible.', 'error');
      return;
    }

    if (mesasNecesarias > mesasDisponibles) { 
      showSnackbar('No hay suficientes mesas disponibles para la cantidad de invitados.', 'warning');
      return;
    }

    const datosReserva = {
      id_orden: reservaData.id_orden,
      codigo_validacion: codigo,
      id_local: localSeleccionado,
      fecha: fecha,
      id_horario: hora,
      invitados: invitados,
      preciodif:precioDiferente,
      nuevoPrecio:nuevoPrecio
    };

    try {
      const response = await axios.post('https://reservas.familypark.cl/backend/mof/guardarreserva', datosReserva);
      if (response.data.status === 'ok') {
        setMensajeExito(response.data.detalle);
        setProcesoCompletado(true);
      } else {
        showSnackbar(response.data.detalle , 'error');
      }
    } catch (error) {
      showSnackbar('Error al guardar la reserva. Intenta nuevamente.', 'error');
    }
  };

  // Anular reserva
  const handleAnularReserva = async () => {
    if (numeroOrdenAnulacion.trim() === '') {
      showSnackbar('Por favor, ingresa el número de orden.', 'warning');
      return;
    }

    if (numeroOrdenAnulacion !== reservaData.id_orden) {
      showSnackbar('El número de orden no coincide con la reserva.', 'error');
      return;
    }

    if (!validarDatosBancarios()) {
      showSnackbar('Por favor, completa todos los datos bancarios para el reembolso.', 'warning');
      return;
    }

    try {
      const response = await axios.post('https://reservas.familypark.cl/backend/mof/anular-reserva', {
        id_orden: reservaData.id_orden,
        codigo_validacion: codigo,
        datos_bancarios: datosBancarios
      });
      if (response.data.status === 'ok') {
        setMensajeExito(response.data.detalle);
        setProcesoCompletado(true);
      } else {
        showSnackbar(response.data.detalle , 'error');
      }
    } catch (error) {
      showSnackbar('Error al anular la reserva. Intenta nuevamente.', 'error');
    }
  };

  // Obtener el nombre del local seleccionado
  const nombreLocal = locales.find((local) => local.id_local === reservaData?.id_local)?.nombre_local || '';

  // Obtener la hora seleccionada
  const horaSeleccionada = horariosDisponibles.find((h) => h.id_hr === reservaData?.id_horario)?.hora || '';

  // Pantalla de éxito
  if (procesoCompletado) {
    return (
      <Container>
        <Box textAlign="center" mt={10}>
          <Typography variant="h4" className="color-primary font-bango" gutterBottom>
            ¡Proceso completado con éxito!
          </Typography>
          <Typography variant="body1" gutterBottom>
            {mensajeExito}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            className="roundedbutton"
            onClick={volverAlInicio}
            style={{ marginTop: '20px' }}
          >
            Volver al inicio
          </Button>
        </Box>
      </Container>
    );
  }

  return (
    <Container>
      {/* Paso 1: Ingresar número de reserva y enviar código */}
      {!reservaValidada && (
        <>
          <Typography variant="h4" className="color-primary" gutterBottom>
            Editar Reserva
          </Typography>
          <Typography variant="body1" gutterBottom>
            Validaremos tu reserva enviando un código al correo con el que fue registrada la reserva.
          </Typography>
          <Box component="form" noValidate autoComplete="off">
            <TextField
              label="Número de Reserva"
              variant="outlined"
              fullWidth
              margin="normal"
              value={reservaId}
              onChange={(e) => setReservaId(e.target.value)}
            />
            <Button
              variant="contained"
              color="primary"
              className="roundedbutton"
              onClick={handleEnviarCodigo}
              disabled={!validarNumeroReserva()}
            >
              Enviar Código
            </Button>
            {error && <Typography color="error" gutterBottom={1} marginTop={2}>{error}</Typography>}

            {codigoEnviado && (
              <>
                <Typography variant="body1" className="color-primary font-bango" gutterBottom={1} marginTop={5}>
                  Por favor, ingresa el código que se ha enviado a tu correo.
                </Typography>
                <TextField
                  label="Código de Validación"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  value={codigo}
                  onChange={(e) => setCodigo(e.target.value)}
                />
                <Button
                  variant="contained"
                  color="secondary"
                  className="roundedbutton"
                  onClick={handleValidarReserva}
                  disabled={codigo.trim() === ''}
                >
                  Validar Reserva
                </Button>
              </>
            )}
          </Box>
        </>
      )}

      {/* Paso 2: Editar o Anular reserva (solo si está validada) */}
      {reservaValidada && reservaData && (
        <>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h4" gutterBottom>
              Hola <span className="color-primary">{reservaData.ord_nombre} {reservaData.ord_apellido}</span>,<br /> estás editando:
            </Typography>
            <Button
              variant="outlined"
              color="primary"
              className='roundedbutton'
              onClick={volverAlInicio}
            >
              Volver al inicio
            </Button>
          </Box>
          
          <Typography variant="p" gutterBottom className="color-primary font-bango">
            Reserva #{reservaData.id_orden} para el día {reservaData.ord_fecreserva} a las {horaSeleccionada} en el local {nombreLocal}.
          </Typography>

          {/* Opciones: Editar o Anular */}
          <Box marginBottom={4} marginTop={4}>
            {/*<Button
              variant={modoEdicion ? "contained" : "outlined"}
              color="primary"
              className="roundedbutton"
              onClick={() => setModoEdicion(true)}
              style={{ marginRight: '10px' }}
            >
              Editar Reserva
            </Button>
            <Button
              variant={!modoEdicion ? "contained" : "outlined"}
              color="secondary"
              className="roundedbutton"
              onClick={() => setModoEdicion(false)}
            >
              Anular Reserva
            </Button>*/}
          </Box>

          {/* Formulario de Edición */}
          {modoEdicion && (
            <Box component="form" noValidate autoComplete="off">
              {locales.length > 0 && (
                <FormControl fullWidth margin="normal">
                  <InputLabel>Local</InputLabel>
                  <Select
                    value={localSeleccionado}
                    onChange={(e) => setLocalSeleccionado(e.target.value)}
                    label="Local"
                  >
                    {locales.map((local) => (
                      <MenuItem key={local.id_local} value={local.id_local}>
                        {local.nombre_local}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}

              <TextField
                label="Fecha"
                variant="outlined"
                fullWidth
                margin="normal"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={fecha}
                onChange={(e) => setFecha(e.target.value)}
              />

              {horariosDisponibles.length > 0 && (
                <FormControl fullWidth margin="normal">
                  <InputLabel>Hora</InputLabel>
                  <Select
                    value={hora}
                    onChange={(e) => setHora(e.target.value)}
                    label="Hora"
                  >
                    {horariosDisponibles.map((horario) => (
                      <MenuItem key={horario.id_hr} value={horario.id_hr}>
                        {horario.hora} (Mesas disponibles: {horario.cupos_disponibles})
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}

              <TextField
                label="Cantidad de Invitados"
                variant="outlined"
                fullWidth
                margin="normal"
                type="number"
                value={invitados}
                onChange={(e) => setInvitados(e.target.value)}
              />

              <Typography variant="body1" gutterBottom>
                Mesas necesarias: {mesasNecesarias} (Cada 25 invitados ocupan 1 mesa)
              </Typography>
              <Typography variant="body1" gutterBottom>
                Mesas disponibles: {mesasDisponibles}
              </Typography>
              {precioDiferente && (
      <Box 
        sx={{
          border: '1px solid #ff9800',
          borderRadius: '4px',
          padding: '16px',
          margin: '16px 0',
          backgroundColor: '#fff3e0'
        }}
      >
        <Typography variant="body1" color="error" gutterBottom>
          ¡ATENCIÓN! El precio para este horario ha cambiado.
        </Typography>
        <Typography variant="body1" gutterBottom>
          Precio original p/p: ${precioOriginal.toLocaleString('es-CL')}
        </Typography>
        <Typography variant="body1" gutterBottom>
          Nuevo precio p/p: ${nuevoPrecio.toLocaleString('es-CL')}
        </Typography>
        
        <FormControlLabel
          control={
            <Checkbox 
              checked={aceptaNuevoPrecio}
              onChange={(e) => setAceptaNuevoPrecio(e.target.checked)}
              color="primary"
            />
          }
          label="Acepto el nuevo precio para mi reserva"
        />
      </Box>
    )}

              {error && <Typography color="error">{error}</Typography>}

              <Button 
      variant="contained" 
      className="roundedbutton" 
      color="primary" 
      onClick={handleEditarReserva}
      disabled={precioDiferente && !aceptaNuevoPrecio}
    >
      Guardar Cambios
    </Button>
            </Box>
          )}

          {/* Formulario de Anulación con datos bancarios */}
          {!modoEdicion && (
            <Box component="form" noValidate autoComplete="off">
              <Typography variant="body1" gutterBottom>
                Para anular la reserva, confirma el número de orden:
              </Typography>
              <TextField
                label="Número de Orden"
                variant="outlined"
                fullWidth
                margin="normal"
                value={numeroOrdenAnulacion}
                onChange={(e) => setNumeroOrdenAnulacion(e.target.value)}
              />
              
              <Typography variant="h6" gutterBottom style={{ marginTop: '20px' }}>
                Datos Bancarios para Reembolso
              </Typography>
              
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Nombre del Titular"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="nombreTitular"
                    value={datosBancarios.nombreTitular}
                    onChange={handleDatosBancariosChange}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="RUT del Titular"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="rutTitular"
                    value={datosBancarios.rutTitular}
                    onChange={handleDatosBancariosChange}
                    placeholder="Ej: 12345678-9"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Número de Cuenta"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="numeroCuenta"
                    value={datosBancarios.numeroCuenta}
                    onChange={handleDatosBancariosChange}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel>Tipo de Cuenta</InputLabel>
                    <Select
                      label="Tipo de Cuenta"
                      name="tipoCuenta"
                      value={datosBancarios.tipoCuenta}
                      onChange={handleDatosBancariosChange}
                    >
                      <MenuItem value="Cuenta Corriente">Cuenta Corriente</MenuItem>
                      <MenuItem value="Cuenta Vista">Cuenta Vista / Cuenta RUT</MenuItem>
                      <MenuItem value="Cuenta de Ahorro">Cuenta de Ahorro</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Banco"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="banco"
                    value={datosBancarios.banco}
                    onChange={handleDatosBancariosChange}
                  />
                </Grid>
              </Grid>
              
              <Button
                variant="contained"
                color="secondary"
                className="roundedbutton"
                onClick={handleAnularReserva}
                disabled={numeroOrdenAnulacion.trim() === '' || !validarDatosBancarios()}
                style={{ marginTop: '20px' }}
              >
                Anular Reserva y Solicitar Reembolso
              </Button>
            </Box>
          )}
        </>
      )}

      {/* Snackbar para mostrar mensajes */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default EditarReserva;